import React, { Fragment, PureComponent } from 'react';

import { Endpoint, Route } from '@philips-emr/hpms-stipulator-commons';
import StipulatorContext, { Entry, IeTipoEstipulante } from '@philips-emr/hpms-stipulator-commons/lib/contexts/stipulator-context';
import { ContextMenu, Option } from '@philips-emr/tws-components';
import { Placement } from '@philips-emr/tws-constants';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { eventListener, string } from '@philips-emr/tws-core/lib/component/prop-types';
import { HttpService, MessageService } from '@philips-emr/tws-core/lib/services';
import HistoryService from '@philips-emr/tws-core/lib/services/history-service'
import { isUndefined } from '@philips-emr/tws-utils';

import HpmsBeneficiaryChangeCardApi from '../../api/hpms-beneficiary-change-card-api';

@AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: HpmsBeneficiaryChangeCardApi })
class HpmsContextMenuBeneficiaryChange extends PureComponent {

  state = {
    dados: {},
  }

  static propTypes = {
    nrSeqBeneficiario: string,
    cdPessoaFisica: string,
    onDadosPessoaisClick: eventListener,
  }

  componentDidMount() {
    const { nrSeqContrato } = StipulatorContext.getCurrentContract();
    const { nrSeqBeneficiario } = this.props;

    HttpService.get(Endpoint.GET.POP_UP_ALT_BENEFICIARY, { nrSeqBeneficiario, nrSeqContrato }).then(response => {
      this.setState({ dados: response.body });
    });
  }

  onDadosPessoais(nrSeqBeneficiario, cdPessoaFisica) {
    const { nrSeqGrupoContratoWeb, nrSeqContrato } = HistoryService.getCurrentRouteParams();
    HistoryService.push(Route.BENEFICIARY_DATA, { nrSeqBeneficiario, cdPessoaFisica, nrSeqGrupoContratoWeb, nrSeqContrato });
  }

  onAlterarProduto(nrSeqBeneficiario, cdPessoaFisica) {
    const { nrSeqGrupoContratoWeb, nrSeqContrato } = HistoryService.getCurrentRouteParams();
    HistoryService.push(Route.ALTERAR_PRODUTO, { nrSeqGrupoContratoWeb, nrSeqContrato, nrSeqBeneficiario, cdPessoaFisica });
  }

  onSolicitarRepasse(nrSeqBeneficiario) {
    const { nrSeqGrupoContratoWeb, nrSeqContrato } = HistoryService.getCurrentRouteParams();
    HistoryService.push(Route.SOLICITAR_REPASSE, { nrSeqGrupoContratoWeb, nrSeqContrato, nrSeqBeneficiario });
  }

  onFinalizarRepasse(nrSeqBeneficiario) {
    const { nrSeqGrupoContratoWeb, nrSeqContrato } = HistoryService.getCurrentRouteParams();
    HistoryService.push(Route.FINALIZAR_REPASSE, { nrSeqGrupoContratoWeb, nrSeqContrato, nrSeqBeneficiario });
  }

  onSegundaViaCartao(nrSeqBeneficiario) {
    HistoryService.push(Route.CARTAO_SOLICITAR, { nrSeqBeneficiario });
  }

  onAlterarMatricula(nrSeqBeneficiario) {
    HistoryService.push(Route.ALTERAR_MATRICULA, { nrSeqBeneficiario });
  }

  onMigrarContrato(nrSeqBeneficiario) {
    HistoryService.push(Route.MIGRAR_CONTRATO, { nrSeqBeneficiario });
  }
  onAlterarLocalizacao(nrSeqBeneficiario) {
    HistoryService.push(Route.ALTERAR_LOCALIZACAO, { nrSeqBeneficiario });
  }
  onAlterarDataAdmissao(nrSeqBeneficiario) {
    HistoryService.push(Route.ALTERAR_ADMISSAO, { nrSeqBeneficiario });
  }

  onTransferirTitularidade(nrSeqBeneficiario) {
    HistoryService.push(Route.TRANSFERIR_TITULARIDADE, { nrSeqBeneficiario });
  }

  onAlterarVinculo(nrSeqBeneficiario) {
    HistoryService.push(Route.ALTERAR_VINCULO, { nrSeqBeneficiario });
  }

  render() {
    const { nrSeqBeneficiario, cdPessoaFisica } = this.props;
    const { dtRescisao, ieSituacao } = this.state.dados;
    const showOtherOptions = isUndefined(dtRescisao) && ieSituacao !== 'I' && StipulatorContext.getCurrentContract().ieTipoEstipulante === IeTipoEstipulante.PJ;

    return (
      <ContextMenu placement={Placement.RIGHT}>
        <Option onClick={() => this.onDadosPessoais(nrSeqBeneficiario, cdPessoaFisica)} visible={true} value={MessageService.translate('stipulator.dados-cadastrais')} />

        {showOtherOptions && (
          <Fragment>
            {StipulatorContext.isAllowedTwsFunction('9126_2') &&
              <Option onClick={() => this.onAlterarDataAdmissao(nrSeqBeneficiario)} visible={this.state.dados != null && this.state.dados.nrSequenciaTitular == null} value={MessageService.translate('stipulator.alterar-data-admissao')} />}

            {StipulatorContext.isAllowedTwsFunction('9126_4') &&
              <Option onClick={() => this.onAlterarLocalizacao(nrSeqBeneficiario)} visible={true} value={MessageService.translate('stipulator.alterar-localizacao')} />}

            {StipulatorContext.isAllowedTwsFunction('9126_5') &&
              <Option onClick={() => this.onAlterarMatricula(nrSeqBeneficiario)} visible={true} value={MessageService.translate('stipulator.alterar-matricula')} />}

            {StipulatorContext.isAllowedTwsFunction('9126_6', Entry.T) &&
              <Option onClick={() => this.onAlterarProduto(nrSeqBeneficiario, cdPessoaFisica)} visible={this.state.dados != null && this.state.dados.nrSequenciaTitular == null} value={MessageService.translate('stipulator.alterar-produto')} />}

            {StipulatorContext.isAllowedTwsFunction('9126_6') &&
              <Option onClick={() => this.onAlterarProduto(nrSeqBeneficiario, cdPessoaFisica)} visible={true} value={MessageService.translate('stipulator.alterar-produto')} />}

            {StipulatorContext.isAllowedTwsFunction('9126_7') &&
              <Option onClick={() => this.onAlterarVinculo(nrSeqBeneficiario)} visible={true} value={MessageService.translate('stipulator.alterar-vinculo')} />}

            {StipulatorContext.isAllowedTwsFunction('9126_10') &&
              <Option onClick={() => this.onFinalizarRepasse(nrSeqBeneficiario)} visible={this.state.dados != null && this.state.dados.nrSequenciaRepasse != null} value={MessageService.translate('stipulator-finalizar.compartilhamento.risco')} />}

            {StipulatorContext.isAllowedTwsFunction('9126_8') &&
              <Option onClick={() => this.onMigrarContrato(nrSeqBeneficiario)} visible={this.state.dados != null && this.state.dados.nrSequenciaTitular == null && this.state.dados.tipoContrato == 'C'} value={MessageService.translate('stipulator.migrar-contrato')} />}

            {StipulatorContext.isAllowedTwsFunction('9126_10') &&
              <Option onClick={() => this.onSolicitarRepasse(nrSeqBeneficiario)} visible={this.state.dados != null && this.state.dados.nrSequenciaRepasse == null} value={MessageService.translate('stipulator.compartilhamento-risco')} />}

            {StipulatorContext.isAllowedTwsFunction('9126_11') &&
              <Option onClick={() => this.onSegundaViaCartao(nrSeqBeneficiario)} visible={true} value={MessageService.translate('stipulator.solicitar-segunda-via-carteira')} />}

            {StipulatorContext.isAllowedTwsFunction('9126_12') &&
              <Option onClick={() => this.onTransferirTitularidade(nrSeqBeneficiario)} visible={this.state.dados != null && this.state.dados.nrSequenciaTitular == null && this.state.dados.tipoContrato == 'C' && this.state.dados.qtdDependentes > 0} value={MessageService.translate('stipulator.transferir-titularidade')} />}
          </Fragment>
        )}
      </ContextMenu>

    );
  }
}

export default HpmsContextMenuBeneficiaryChange
